import { PoliciesQuery } from 'query/policy/query';

export const conditionPolicies = (policies: PoliciesQuery['policies'], sortBy: string) => {
  const period = sortBy === 'Monthly' ? 'monthlyPremium' : 'annualPremium';

  return [...policies].sort((a, b) => a[period] - b[period]).filter((p) => p[period] > 0);
};
